import { Translator } from 'Translator';
import classnames from 'classnames';
import React from 'react';

import SpeakerCrossedIcon from '../icons/SpeakerCrossedIcon';
import SpeakerIcon from '../icons/SpeakerIcon';

const CSS = require('./MuteButton.module.scss');

interface MuteButtonProps {
  muted: boolean;
  onClick: (event) => void;
  className?: string;
}

function MuteButton({ muted, onClick, className }: MuteButtonProps) {
  const label = muted
    ? Translator.translate('Common.Labels.unmute', {}, true, 'Unmute')
    : Translator.translate('Common.Labels.mute', {}, true, 'Mute');

  return (
    <button
      className={classnames(CSS.MuteButton, className)}
      onClick={onClick}
      aria-label={label}
    >
      {muted && <SpeakerCrossedIcon className={CSS.MuteButtonIcon} />}
      {!muted && <SpeakerIcon className={CSS.MuteButtonIcon} />}
    </button>
  );
}

export default MuteButton;
